import { AnimatedSplash } from '@/components/animated-splash';
import { useAuthStatus } from '@/hooks/use-auth-status';
import React, { useCallback, useState } from 'react';

/**
 * Holds the animated splash over the app until auth has resolved once, then
 * unmounts it for good.
 *
 * Must render inside `AuthProvider` (for `useAuthStatus`) and after the routes
 * it covers, so it paints above them. Mounting it before the native splash is
 * hidden is what keeps the logo on screen for every frame of the hand-off.
 *
 * The minimum-display floor and the hung-auth cap live in `AnimatedSplash`;
 * this component only decides *whether* the app still needs covering.
 */
function SplashBridge() {
  const authStatus = useAuthStatus();
  const [finished, setFinished] = useState(false);

  const handleFinish = useCallback(() => setFinished(true), []);

  // Terminal: once lifted, never come back — a later 'loading' (e.g. a token
  // refresh) must not slam the splash over a running app.
  if (finished) {
    return null;
  }

  return (
    <AnimatedSplash
      visible={authStatus === 'loading'}
      onFinish={handleFinish}
    />
  );
}

export { SplashBridge };
